import React, { useEffect, useContext, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';

function ModalSellBlocked() {
  const { t } = useTranslation();

  const {
    updateUserInfoBlocked,
    updateShowModalSellBlocked,
    updateFocusOnMainScreen,
    userInfoBlocked,
    lastDataBingoTicket,
    updateLastDataBingoTicket,
  } = useContext(AppContext);

  const lastDataBingoTicketRef = useRef(lastDataBingoTicket);
  useEffect(() => {
    lastDataBingoTicketRef.current = lastDataBingoTicket;
  }, [lastDataBingoTicket]);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {}, [socket]);

  //* CONFIRM REGISTRATION BUTTON (search if phone exist or register the user)
  const handleConfirm = async () => {
    updateLastDataBingoTicket(false);
    updateShowModalSellBlocked(false);
  };

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <h1>
              {t('sales.sellBlockedTitle')}{' '}
              <>
                {lastDataBingoTicketRef.current && (
                  <>
                    {(() => {
                      const v = String(lastDataBingoTicketRef.current ?? '');
                      const len = v.length;

                      if (len <= 4) return `(CH - ${v})`;
                      if (len === 7) return `(OK D. - ${v})`;
                      return `(WG - ${v})`;
                    })()}
                  </>
                )}
              </>
            </h1>

            <p>{t('sales.sellBlockedText')}</p>

            <div
              className="react-confirm-alert-button-group"
              style={{ marginTop: '55px' }}
            >
              <button
                className="btn-custom-yes"
                onClick={() => {
                  handleConfirm();
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px', // Space between icon and text
                }}
              >
                <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                {t('sales.confirm')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalSellBlocked;
